import { render, staticRenderFns } from "./ActivityMemorize.vue?vue&type=template&id=670d4be4&scoped=true&"
import script from "./ActivityMemorize.vue?vue&type=script&lang=js&"
export * from "./ActivityMemorize.vue?vue&type=script&lang=js&"
import style0 from "./ActivityMemorize.vue?vue&type=style&index=0&id=670d4be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670d4be4",
  null
  
)

export default component.exports